var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-account" }, [
    _c("h1", [_vm._v("Sign Up")]),
    _c(
      "form",
      {
        directives: [
          {
            name: "disable-all",
            rawName: "v-disable-all",
            value: _vm.under18,
            expression: "under18"
          }
        ],
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "row", class: _vm.v$.email.$error ? "has_error" : "" },
          [
            _c("label", { attrs: { for: "user_email" } }, [
              _vm._v("Email (Required)")
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email"
                }
              ],
              attrs: {
                type: "email",
                name: "email",
                id: "user_email",
                readonly: _vm.emailChecked,
                "aria-describedby": "user_email_error"
              },
              domProps: { value: _vm.email },
              on: {
                change: _vm.v$.email.$touch,
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.email = $event.target.value
                }
              }
            }),
            _vm._l(_vm.v$.email.$errors, function(error) {
              return _c("p", {
                key: error.$uid,
                staticClass: "error",
                attrs: { role: "status", id: "user_email_error" },
                domProps: { innerHTML: _vm._s(error.$message) }
              })
            })
          ],
          2
        ),
        _vm.profileAlreadyExists
          ? _c("div", { staticClass: "row" }, [
              _c("p", [_vm._v("Please check your email address to continue.")])
            ])
          : _vm._e(),
        _vm.emailChecked
          ? _c("div", [
              _c("div", { staticClass: "row two-cols" }, [
                _c(
                  "div",
                  { class: _vm.v$.first_name.$error ? "has_error" : "" },
                  [
                    _c("label", { attrs: { for: "user_first_name" } }, [
                      _vm._v("First Name")
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.first_name,
                          expression: "first_name"
                        }
                      ],
                      attrs: {
                        type: "text",
                        name: "first_name",
                        id: "user_first_name",
                        "aria-describedby": "user_first_name_error"
                      },
                      domProps: { value: _vm.first_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.first_name = $event.target.value
                        }
                      }
                    }),
                    _vm._l(_vm.v$.first_name.$errors, function(error) {
                      return _c("p", {
                        key: error.$uid,
                        staticClass: "error",
                        attrs: { role: "status", id: "user_first_name_error" },
                        domProps: { innerHTML: _vm._s(error.$message) }
                      })
                    })
                  ],
                  2
                ),
                _c(
                  "div",
                  { class: _vm.v$.last_name.$error ? "has_error" : "" },
                  [
                    _c("label", { attrs: { for: "user_last_name" } }, [
                      _vm._v("Last Name")
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.last_name,
                          expression: "last_name"
                        }
                      ],
                      attrs: {
                        type: "text",
                        name: "last_name",
                        id: "user_last_name",
                        "aria-describedby": "user_last_name_error"
                      },
                      domProps: { value: _vm.last_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.last_name = $event.target.value
                        }
                      }
                    }),
                    _vm._l(_vm.v$.last_name.$errors, function(error) {
                      return _c("p", {
                        key: error.$uid,
                        staticClass: "error",
                        attrs: { role: "status", id: "user_last_name_error" },
                        domProps: { innerHTML: _vm._s(error.$message) }
                      })
                    })
                  ],
                  2
                )
              ])
            ])
          : _vm._e(),
        !_vm.profileAlreadyExists
          ? _c("div", [
              _c("div", { staticClass: "row two-cols" }, [
                _c(
                  "div",
                  { class: _vm.v$.birth_month.$error ? "has_error" : "" },
                  [
                    _c("label", { attrs: { for: "user_birth_month" } }, [
                      _vm._v("Birth Month (MM) (Required)")
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.birth_month,
                          expression: "birth_month"
                        }
                      ],
                      attrs: {
                        type: "number",
                        maxlength: "2",
                        name: "birth_month",
                        id: "user_birth_month",
                        "aria-describedby": "user_birth_month_error"
                      },
                      domProps: { value: _vm.birth_month },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.birth_month = $event.target.value
                        }
                      }
                    }),
                    _vm._l(_vm.v$.birth_month.$errors, function(error) {
                      return _c("p", {
                        key: error.$uid,
                        staticClass: "error",
                        attrs: { role: "status", id: "user_birth_month_error" },
                        domProps: { innerHTML: _vm._s(error.$message) }
                      })
                    })
                  ],
                  2
                ),
                _c(
                  "div",
                  { class: _vm.v$.birth_year.$error ? "has_error" : "" },
                  [
                    _c("label", { attrs: { for: "user_birth_year" } }, [
                      _vm._v("Birth Year (YYYY) (Required)")
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.birth_year,
                          expression: "birth_year"
                        }
                      ],
                      attrs: {
                        type: "number",
                        name: "birth_year",
                        id: "user_birth_year",
                        "aria-describedby": "user_birth_year_error"
                      },
                      domProps: { value: _vm.birth_year },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.birth_year = $event.target.value
                        }
                      }
                    }),
                    _vm._l(_vm.v$.birth_year.$errors, function(error) {
                      return _c("p", {
                        key: error.$uid,
                        staticClass: "error",
                        attrs: { role: "status", id: "user_birth_year_error" },
                        domProps: { innerHTML: _vm._s(error.$message) }
                      })
                    })
                  ],
                  2
                )
              ])
            ])
          : _vm._e(),
        _vm.emailChecked
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass: "row",
                  class: _vm.v$.postal_code.$error ? "has_error" : ""
                },
                [
                  _c("label", { attrs: { for: "user_postal_code" } }, [
                    _vm._v("Zip Code")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.postal_code,
                        expression: "postal_code"
                      }
                    ],
                    attrs: {
                      type: "text",
                      name: "postal_code",
                      id: "user_postal_code",
                      "aria-describedby": "user_postal_code_error"
                    },
                    domProps: { value: _vm.postal_code },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.postal_code = $event.target.value
                      }
                    }
                  }),
                  _vm._l(_vm.v$.postal_code.$errors, function(error) {
                    return _c("p", {
                      key: error.$uid,
                      staticClass: "error",
                      attrs: { role: "status", id: "user_postal_code_error" },
                      domProps: { innerHTML: _vm._s(error.$message) }
                    })
                  })
                ],
                2
              ),
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass: "row",
                  class: _vm.v$.password.$error ? "has_error" : ""
                },
                [
                  _c("label", { attrs: { for: "user_password" } }, [
                    _vm._v("Password")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password"
                      }
                    ],
                    attrs: {
                      type: "password",
                      name: "password",
                      id: "user_password",
                      "aria-describedby": "user_password_error"
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.password = $event.target.value
                      }
                    }
                  }),
                  _vm._l(_vm.v$.password.$errors, function(error) {
                    return _c("p", {
                      key: error.$uid,
                      staticClass: "error",
                      attrs: { role: "status", id: "user_password_error" },
                      domProps: { innerHTML: _vm._s(error.$message) }
                    })
                  })
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "row",
                  class: _vm.v$.password_confirmation.$error ? "has_error" : ""
                },
                [
                  _c(
                    "label",
                    { attrs: { for: "user_password_confirmation" } },
                    [_vm._v("Confirm Password")]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password_confirmation,
                        expression: "password_confirmation"
                      }
                    ],
                    attrs: {
                      type: "password",
                      name: "password_confirmation",
                      id: "user_password_confirmation",
                      "aria-describedby": "user_password_confirmation_error"
                    },
                    domProps: { value: _vm.password_confirmation },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.password_confirmation = $event.target.value
                      }
                    }
                  }),
                  _vm.v$.password_confirmation.$errors
                    ? _c("p", {
                        staticClass: "error",
                        attrs: {
                          role: "status",
                          id: "user_password_confirmation_error"
                        }
                      })
                    : _vm._e()
                ]
              )
            ])
          : _vm._e(),
        !_vm.profileAlreadyExists
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass: "row",
                  class: _vm.v$.privacy_policy.$error ? "has_error" : ""
                },
                [
                  _c("label", { staticClass: "checkbox-input" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.privacy_policy,
                          expression: "privacy_policy"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        name: "privacy_policy",
                        id: "user_privacy_policy"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.privacy_policy)
                          ? _vm._i(_vm.privacy_policy, null) > -1
                          : _vm.privacy_policy
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.privacy_policy,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.privacy_policy = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.privacy_policy = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.privacy_policy = $$c
                          }
                        }
                      }
                    }),
                    _c(
                      "span",
                      {
                        staticClass:
                          "checkbox-input__checkbox checkbox--toggle-all toggle-all-true"
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon",
                            attrs: {
                              viewBox: "0 0 16 14",
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "currentColor"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M4.69 10.198 1.664 7.044 0 8.778l3.993 4.162.005-.005.729.76L16 1.945 14.304.177z",
                                fill: "currentColor"
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._m(1)
                  ]),
                  _vm._l(_vm.v$.privacy_policy.$errors, function(error) {
                    return _c("p", {
                      key: error.$uid,
                      staticClass: "error",
                      attrs: { role: "status" },
                      domProps: { innerHTML: _vm._s(error.$message) }
                    })
                  })
                ],
                2
              )
            ])
          : _vm._e(),
        _vm.emailChecked
          ? _c("div", [
              _c("div", { staticClass: "row" }, [
                _c("label", { staticClass: "checkbox-input" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.subscribe,
                        expression: "subscribe"
                      }
                    ],
                    attrs: {
                      type: "checkbox",
                      name: "subscribe",
                      id: "user_subscribe"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.subscribe)
                        ? _vm._i(_vm.subscribe, null) > -1
                        : _vm.subscribe
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.subscribe,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.subscribe = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.subscribe = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.subscribe = $$c
                        }
                      }
                    }
                  }),
                  _c(
                    "span",
                    {
                      staticClass:
                        "checkbox-input__checkbox checkbox--toggle-all toggle-all-true"
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "icon",
                          attrs: {
                            viewBox: "0 0 16 14",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "currentColor"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M4.69 10.198 1.664 7.044 0 8.778l3.993 4.162.005-.005.729.76L16 1.945 14.304.177z",
                              fill: "currentColor"
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _c("div", { staticClass: "checkbox-input__label-text" }, [
                    _vm._v(
                      "I’d like to receive product updates, offers and cart follow-ups from :ratio via email (optional)"
                    )
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm.under18
          ? _c("div", { staticClass: "btn" }, [
              _vm._v("Sorry, you are not eligible to register at this time.")
            ])
          : _vm._e(),
        !_vm.under18 && !_vm.profileAlreadyExists
          ? _c("div", { staticClass: "row" }, [
              _c("input", {
                staticClass: "btn--primary",
                attrs: { type: "submit" },
                domProps: {
                  value: _vm.emailChecked ? "Create Account" : "Check Email"
                }
              })
            ])
          : _vm._e(),
        _c("div", { staticClass: "row link" }, [
          _vm._v("Forgot Password? "),
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.$parent.setPage("forgot")
                }
              }
            },
            [_vm._v("Click here")]
          )
        ]),
        _c("div", { staticClass: "row link" }, [
          _vm._v("Already have an account? "),
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.$parent.setPage("signin")
                }
              }
            },
            [_vm._v("Login here")]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("label", { attrs: { for: "user_question1" } }, [
        _vm._v("What's your dietary preference?")
      ]),
      _c(
        "select",
        {
          attrs: {
            name: "question1",
            id: "user_question1",
            "data-question": "DietPreference",
            "data-question-id": "8270a1d0-46c1-4b88-a360-bffbafd337da"
          }
        },
        [
          _c("option", { attrs: { disabled: "", selected: "" } }, [
            _vm._v("Select Answer")
          ]),
          _c("option", { attrs: { value: "Searching for KETO Snacks" } }, [
            _vm._v("Searching for KETO Snacks")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "Low Carb/Low Sugar Solutions" } }, [
            _vm._v("Low Carb/Low Sugar Solutions")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "Protein Seeker" } }, [
            _vm._v("Protein Seeker")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "checkbox-input__label-text" }, [
      _vm._v("I accept the General Mills "),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://www.generalmills.com/privacy-security/us-english-privacy-policy",
            target: "_blank"
          }
        },
        [_vm._v("Privacy Policy")]
      ),
      _vm._v(
        " and agree that my information may be used across the General Mills  "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.generalmills.com/food-we-make/brands",
            target: "_blank"
          }
        },
        [_vm._v("family of brands")]
      ),
      _vm._v(". I further agree to the "),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://www.generalmills.com/privacy-security/legal-terms/us-english-terms-of-use",
            target: "_blank"
          }
        },
        [_vm._v("Terms and Conditions")]
      ),
      _vm._v(" and the "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.generalmills.com/community-rules",
            target: "_blank"
          }
        },
        [_vm._v("Community Rules")]
      ),
      _vm._v(
        ". I, also, understand that :ratio may send me emails relating to my participation in this community. (required)"
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }